import React from 'react';
import HeroSection from 'components/container/HeroSection';
import CTASection from 'components/container/CTASection/CTASection';
import FeatureGrid from 'components/container/FeatureGrid';
import ContentPanel from 'components/container/ContentPanel';
import StylingMockLayout from '../shared/StylingMockLayout';
import './StylingMockContainers.css';

/**
 * Styling Mock Containers Page
 * Showcases all container components
 */
const StylingMockContainers = () => {

  const features = [
    { icon: '🚀', title: 'Feature 1', description: 'Description of feature 1' },
    { icon: '⚡', title: 'Feature 2', description: 'Description of feature 2' },
    { icon: '🎯', title: 'Feature 3', description: 'Description of feature 3' }
  ];

  return (
    <StylingMockLayout>
      <div className="styling-mock-containers">
        <div className="styling-mock-section">
          <h2 className="styling-mock-section-title">Container Components</h2>
          <p className="styling-mock-section-description">
            View container components including HeroSection, CTASection, FeatureGrid, ContentPanel, and InteractiveNavigation.
          </p>
        </div>

        {/* HeroSection */}
        <div className="styling-mock-section">
          <h3 className="styling-mock-section-title">HeroSection</h3>
          <div className="styling-mock-showcase">
            <div className="styling-mock-showcase-content">
              <HeroSection
                title="Hero Section Example"
                subtitle="This is a hero section with title, subtitle, and button"
                buttonText="Get Started"
                onButtonClick={() => alert('Button clicked!')}
              />
            </div>
            <div className="styling-mock-code-block">
{`<HeroSection
  title="Hero Section Example"
  subtitle="This is a hero section with title, subtitle, and button"
  buttonText="Get Started"
  onButtonClick={() => alert('Button clicked!')}
/>`}
            </div>
          </div>
        </div>

        {/* CTASection */}
        <div className="styling-mock-section">
          <h3 className="styling-mock-section-title">CTASection</h3>
          <div className="styling-mock-showcase">
            <div className="styling-mock-showcase-content">
              <CTASection
                title="Call to Action"
                subtitle="This is a CTA section with buttons and guarantees"
                primaryButton={{ text: 'Primary Action', onClick: () => alert('Primary clicked!') }}
                secondaryButton={{ text: 'Secondary Action', onClick: () => alert('Secondary clicked!') }}
                guarantees={['Guarantee 1', 'Guarantee 2', 'Guarantee 3']}
              />
            </div>
            <div className="styling-mock-code-block">
{`<CTASection
  title="Call to Action"
  subtitle="This is a CTA section with buttons and guarantees"
  primaryButton={{ text: 'Primary Action', onClick: () => {} }}
  secondaryButton={{ text: 'Secondary Action', onClick: () => {} }}
  guarantees={['Guarantee 1', 'Guarantee 2', 'Guarantee 3']}
/>`}
            </div>
          </div>
        </div>

        {/* FeatureGrid */}
        <div className="styling-mock-section">
          <h3 className="styling-mock-section-title">FeatureGrid</h3>
          <div className="styling-mock-showcase">
            <div className="styling-mock-showcase-content">
              <FeatureGrid features={features} />
            </div>
            <div className="styling-mock-code-block">
{`<FeatureGrid features={[
  { icon: '🚀', title: 'Feature 1', description: 'Description of feature 1' },
  { icon: '⚡', title: 'Feature 2', description: 'Description of feature 2' },
  { icon: '🎯', title: 'Feature 3', description: 'Description of feature 3' }
]} />`}
            </div>
          </div>
        </div>

        {/* ContentPanel */}
        <div className="styling-mock-section">
          <h3 className="styling-mock-section-title">ContentPanel</h3>
          <div className="styling-mock-showcase">
            <div className="styling-mock-showcase-content">
              <ContentPanel
                title="Content Panel"
                content={<p>This is a content panel with title and content area.</p>}
              />
            </div>
            <div className="styling-mock-code-block">
{`<ContentPanel
  title="Content Panel"
  content={<p>This is a content panel with title and content area.</p>}
/>`}
            </div>
          </div>
        </div>
      </div>
    </StylingMockLayout>
  );
};

export default StylingMockContainers;

